import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function money(value) {
  return Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function safeFileName(value) {
  return String(value || "")
    .trim()
    .replace(/[^\w-]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function exportPaymentBatchPDF({
  company,
  batch,
  lines = [],
  payrollRunName = "",
}) {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const brandTeal = [0, 128, 128];
  const brandGold = [237, 179, 45];
  const dark = [51, 51, 51];
  const muted = [95, 111, 111];
  const lightBg = [245, 250, 250];

  const batchName = batch?.batch_name || "Payment Batch";
  const paymentDate = batch?.payment_date || "-";
  const paymentMethod = batch?.payment_method || "-";
  const status = batch?.status || "-";
  const totalAmount =
    Number(batch?.total_amount || 0) ||
    lines.reduce((sum, row) => sum + Number(row.amount || 0), 0);

  doc.setFillColor(...brandTeal);
  doc.rect(0, 0, pageWidth, 34, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(255, 255, 255);
  doc.text(company?.company_name || "KostPadi Company", 14, 16);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Payroll Payment Batch", 14, 24);

  doc.setFillColor(...brandGold);
  doc.rect(14, 38, pageWidth - 28, 4, "F");

  doc.setFillColor(...lightBg);
  doc.roundedRect(14, 48, 88, 44, 4, 4, "F");
  doc.roundedRect(108, 48, 88, 44, 4, 4, "F");

  doc.setTextColor(...muted);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("BATCH DETAILS", 18, 56);
  doc.text("SUMMARY", 112, 56);

  doc.setFont("helvetica", "normal");
  doc.setTextColor(...dark);
  doc.setFontSize(9);

  doc.text(`Batch Name: ${batchName}`, 18, 64);
  doc.text(`Payroll Run: ${payrollRunName || "-"}`, 18, 70);
  doc.text(`Payment Date: ${paymentDate}`, 18, 76);
  doc.text(`Payment Method: ${paymentMethod}`, 18, 82);
  doc.text(`Status: ${status}`, 18, 88);

  doc.text(`Total Employees: ${lines.length}`, 112, 64);
  doc.text(`Total Amount: ${money(totalAmount)}`, 112, 70);
  doc.text(`Currency: NGN`, 112, 76);

  const tableRows = lines.map((row, index) => [
    String(index + 1),
    row.employee_name || "-",
    row.bank_name || "-",
    row.bank_account_name || "-",
    row.bank_account_number || "-",
    money(row.amount || 0),
  ]);

  if (!tableRows.length) {
    tableRows.push(["1", "No payment lines", "-", "-", "-", "0.00"]);
  }

  autoTable(doc, {
    startY: 102,
    margin: { left: 14, right: 14 },
    head: [
      ["#", "Employee", "Bank", "Account Name", "Account Number", "Amount"],
    ],
    body: tableRows,
    theme: "grid",
    styles: {
      fontSize: 8.4,
      textColor: dark,
      cellPadding: 3,
      lineColor: [230, 240, 240],
      overflow: "linebreak",
    },
    headStyles: {
      fillColor: brandTeal,
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    foot: [["", "", "", "", "Total", money(totalAmount)]],
    footStyles: {
      fillColor: [240, 249, 249],
      textColor: dark,
      fontStyle: "bold",
    },
    columnStyles: {
      0: { cellWidth: 10 },
      1: { cellWidth: 40 },
      2: { cellWidth: 34 },
      3: { cellWidth: 44 },
      4: { cellWidth: 34 },
      5: { cellWidth: 24, halign: "right" },
    },
  });

  doc.setTextColor(...muted);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text(
    company?.address || "Generated from KostPadi Payroll",
    14,
    pageHeight - 16
  );
  doc.text(
    "This is a system-generated payroll payment batch export.",
    14,
    pageHeight - 10
  );

  doc.save(`Payment_Batch_${safeFileName(batchName)}.pdf`);
}
